import api from '@pray/shared/utils/api';

import type { SeedGroupListEnvelope } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

export type GetGroupsParams = {
  q?: string;
  limit?: number;
  offset?: number;
};

/**
 * The Groups list and the totals of the Groups page in one call.
 *
 * A row carries the member count and the ISP mix, never the member ids: a group can hold thousands
 * of seeds and the list only shows the number. The editor reads the ids from the detail.
 */
export async function getGroups({ q, limit = 100, offset = 0 }: GetGroupsParams = {}) {
  const params: Record<string, string | number> = { limit, offset };
  if (q) params.q = q;

  const res = await api.executeGetRequest<SeedGroupListEnvelope>(GROUPS_URL, params);
  return res.data;
}
